(() => {
  let pendingAddPromise = null;
  const FORM_SELECTOR = [
    'form.vws-card-cart-form',
    'form.vbe-card__cart-form',
    'form.volices-premium-card__cart-form'
  ].join(',');

  const getRoutes = () => ({
    add: window.Theme?.routes?.cart_add_url || '/cart/add.js',
    cart: window.Theme?.routes?.cart_url ? window.Theme.routes.cart_url + '.js' : '/cart.js'
  });

  function ensureFloatingCart() {
    let el = document.getElementById('volices-floating-cart');
    if (el) return el;

    el = document.createElement('button');
    el.id = 'volices-floating-cart';
    el.type = 'button';
    el.hidden = true;
    el.setAttribute('aria-label', 'Open cart');
    el.innerHTML = '<span class="vfc-bag" aria-hidden="true">🛍</span><span class="vfc-text">Cart</span><strong class="vfc-count">0</strong>';
    el.addEventListener('click', async () => {
      try {
        if (pendingAddPromise) await pendingAddPromise;
      } catch (_) {}
      window.location.href = '/cart';
    });
    document.body.appendChild(el);
    return el;
  }

  function updateHeaderCart(count) {
    document.querySelectorAll('cart-icon').forEach((icon) => {
      if (typeof icon.renderCartBubble === 'function') {
        icon.renderCartBubble(count);
      } else {
        const countEl = icon.querySelector('.cart-bubble__text-count');
        const bubble = icon.querySelector('.cart-bubble');
        if (countEl) {
          countEl.textContent = count < 100 ? String(count) : '';
          countEl.classList.toggle('hidden', count === 0);
        }
        if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
        icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      }
    });
  }

  function getDisplayedCount() {
    const header = document.querySelector('.cart-bubble__text-count');
    const n = Number(header?.textContent || 0);
    return Number.isFinite(n) ? n : 0;
  }

  function updateFloatingCart() {
    // Floating VOLICES cart intentionally disabled.
    // Keep the rest of this file active so collection-card add-to-cart
    // and header cart count syncing continue to work normally.
    document.getElementById('volices-floating-cart')?.remove();
  }

  async function fetchCart() {
    const routes = getRoutes();
    const response = await fetch(routes.cart, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Cart refresh failed');
    return response.json();
  }

  async function addFromCardForm(form, button) {
    if (form.dataset.volicesAdding === 'true') return;
    form.dataset.volicesAdding = 'true';

    const original = button?.textContent?.trim() || 'ADD TO CART';
    if (button) {
      button.disabled = true;
      button.textContent = 'ADDING...';
    }

    try {
      const variantId = form.querySelector('input[name="id"]')?.value;
      const quantity = Number(form.querySelector('input[name="quantity"]')?.value || 1);
      if (!variantId) throw new Error('Missing variant ID');

      const optimisticCount = getDisplayedCount() + quantity;
      updateHeaderCart(optimisticCount);
      updateFloatingCart(optimisticCount);

      if (button) {
        button.textContent = 'ADDED ✓';
      }

      const routes = getRoutes();
      pendingAddPromise = fetch(routes.add, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity }]
        })
      }).then(async (response) => {
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || 'Add to cart failed');
        }
        return response;
      });

      await pendingAddPromise;
      pendingAddPromise = null;

      setTimeout(() => {
        if (button) {
          button.textContent = original;
          button.disabled = false;
        }
      }, 1200);

      fetchCart()
        .then((cart) => {
          const realCount = Number(cart.item_count || 0);
          updateHeaderCart(realCount);
          updateFloatingCart(realCount);
        })
        .catch(() => {});
    } catch (error) {
      pendingAddPromise = null;
      const current = getDisplayedCount();
      const rollback = Math.max(0, current - Number(form.querySelector('input[name="quantity"]')?.value || 1));
      updateHeaderCart(rollback);
      updateFloatingCart(rollback);
      console.error('[VOLICES cart]', error);
      if (button) {
        button.textContent = original;
        button.disabled = false;
      }
    } finally {
      form.dataset.volicesAdding = 'false';
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const button = event.submitter instanceof HTMLButtonElement
      ? event.submitter
      : form.querySelector('button[type="submit"]');

    addFromCardForm(form, button);
  }, true);

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest('[data-testid="cart-drawer-trigger"]');
    if (!(trigger instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    try {
      if (pendingAddPromise) await pendingAddPromise;
    } catch (_) {}

    window.location.href = '/cart';
  }, true);

  window.addEventListener('pageshow', () => {
    fetchCart()
      .then((cart) => {
        const count = Number(cart.item_count || 0);
        updateHeaderCart(count);
        updateFloatingCart(count);
      })
      .catch(() => {});
  });
})();